import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { DiscussionsService } from '../../../services/discussions.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';

@Component({
  selector: 'app-discussions-detail',
  templateUrl: './discussions-detail.component.html',
  styleUrls: ['./discussions-detail.component.scss']
})
export class DiscussionsDetailComponent implements OnInit {
    pagecode: string = "disc-detail";
    module: string = "discussion";
    accessdenied: boolean = false;
    constructor(private metaService: Meta, private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router, private discussionService: DiscussionsService, private authentication: AuthenticationService, private common: CommonService) {



        this.route.params.subscribe(val => {

            let map: any = this.route.paramMap;
            this.id = map.destination._value.id;

            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {


                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data

                        this.getDiscussionById();
                        this.getDiscussionTag();
                        this.getDiscussionAnswer();
                        this.addDiscussionView();

                        window.scroll(0, 0);
                        //
                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });




    }

    id: string = "0";
    isFollow: boolean = false;
    followId: any;
    ShowMarkRemoveBestAnswer: boolean = false;
    btnSendDisabled: boolean = false;
    btnSubmitText: string = "Submit";
    relatedTags: string = "";

    ngOnInit(): void {
        //let map: any = this.route.paramMap;
        //this.id = map.destination._value.id;

        //this.getDiscussionById();
        //this.getDiscussionTag();
        //this.getDiscussionAnswer();
    }

    discussion: any;
    discussionTags: any;

    getDiscussionTag() {
        this.discussionService.getDiscussionTag(this.id).subscribe(
            (res: any) => {
                if (res.success) {
                    this.discussionTags = res.data;
                    //console.log("discussionTags", this.discussionTags);
                }
                else {
                    console.error("getDiscussionTag", res.error_message);
                }
            },
            (err: any) => {
                console.error("getDiscussionTag", err)
            }
        );
    }
    addDiscussionView() {
        this.discussionService.addDiscussionView(this.id).subscribe(
            (res: any) => {
                if (res.success) {

                }
                else {
                    console.error("addDiscussionView", res.error_message);
                }
            },
            (err: any) => {
                console.error("addDiscussionView", err)
            }
        );
    }

    showFollowBlock: boolean = true;
    getDiscussionById() {
        this.discussionService.getDiscussionById(this.id).subscribe(
            (res: any) => {
                if (res.success) {
                    res.data.description = this.sanitizer.bypassSecurityTrustHtml(res.data.description);
                    this.discussion = res.data;
                    if (this.discussion.owner_PortalUserId == this.authentication.userData.id) {
                        this.ShowMarkRemoveBestAnswer = true;
                        this.showFollowBlock = false;
                    }
                    //console.log("discussion", this.discussion);
                }
                else {
                    console.error("getDiscussionById", res.error_message);
                }
            },
            (err: any) => {
                console.error("getDiscussionById", err)
            }
        );
    }


    followDiscussion() {
        this.discussionService.followDiscussionBoard(this.discussion.discussionId, this.authentication._authentication.id).subscribe(
            (res: any) => {
                this.isFollow = true;
                this.followId = res;
            },
            (err: any) => {

            });
    }
    unfollowDiscussion() {
        this.discussionService.unfollowDiscussion(this.discussion.discussionId, this.authentication._authentication.id).subscribe(
            (res: any) => {
                if (res != 0) {
                    this.isFollow = false;
                }
            },
            (err: any) => {
            });
    }
    myAnswer: any = "";
    answers: any[] = [];
    getDiscussionAnswer() {
        this.discussionService.getDiscussionAnswer(this.id).subscribe(
            (res: any) => {
                if (res.success) {
                    this.answers = res.data;
                    for (var i = 0; i < this.answers.length; i++) {
                        //this.answers[i]['owner'].contactLogo = "url('" + this.answers[i]['owner'].contactLogo + "')";
                        this.answers[i].answer = this.sanitizer.bypassSecurityTrustHtml(this.answers[i].answer);
                    }
                }
                else {
                    console.error("getDiscussionAnswer", res.error_message);
                }
            },
            (err: any) => {
                console.error("getDiscussionAnswer", err);
            });
    }


    isBestAnswer(item: any) {
        this.discussionService.isBestAnswer(item.discussionAnswerId).subscribe(
            (res: any) => {
                //console.log('is best answer', res);
                if (res.success)
                    item.isBestAnswer = true;
                else {
                    console.error("isBestAnswer", res.error_message);
                }
            },
            (err: any) => {
                console.error("isBestAnswer", err);
            });
    }
    removeBestAnswer(item: any) {
        this.discussionService.removeBestAnswer(item.discussionAnswerId).subscribe(
            (res: any) => {
                //console.log('remove best answer', res)
                item.isBestAnswer = false;
            },
            (err: any) => {

            });
    }

    onSubmitAnswer() {
        if (this.myAnswer == "") {
            this.common.ShowMessage('info', 'your answer is mandatory', '');
        }
        else {
            this.btnSubmitText = "Submitting";
            this.btnSendDisabled = true;
            var answerObj = {
                DiscussionBoardId: this.discussion.discussionId,
                Answer: this.myAnswer,
                Owner_PortalUserId: this.authentication._authentication.id,
                IsBestAnswer: false
            };
            this.discussionService.answerDiscussionBoard(answerObj).subscribe(
                (res: any) => {
                    this.btnSubmitText = "Submit";
                    this.btnSendDisabled = false;
                    if (res.success) {
                        this.myAnswer = "";
                        this.getDiscussionAnswer();
                    }
                    else {
                        console.error("onSubmitAnswer()", res);
                    }


                },
                (err: any) => {
                    console.error("err", err)
                    this.btnSubmitText = "Submit";
                    this.btnSendDisabled = false;
                }
            );
        }
    }

}
